import Link from "next/link";

//local imports
import classes from "@/styles/contact/contact-us.module.css";
import { contactUs } from "@/utils/content";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { useIsMobile } from "@/hooks/useIsMobile";

const svgMap = {
  sales: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="42"
      viewBox="0 0 42 42"
    >
      <path
        id="Path_14"
        data-name="Path 14"
        d="M7.444,3v8.889M3,7.444h8.889M9.667,34.111V43M5.222,38.556h8.889M25.222,3,30.3,18.238,43,23,30.3,27.762,25.222,43l-5.08-15.238L7.444,23l12.7-4.762Z"
        transform="translate(-2 -2)"
        fill="none"
        stroke="#1e3c70"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  ),
  support: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42.773"
      height="33.111"
      viewBox="0 0 42.773 33.111"
    >
      <path
        id="Path_15"
        data-name="Path 15"
        d="M3,11.667,20.533,23.356a4.444,4.444,0,0,0,4.933,0L43,11.667M7.444,36.111H38.556A4.444,4.444,0,0,0,43,31.667V9.444A4.444,4.444,0,0,0,38.556,5H7.444A4.444,4.444,0,0,0,3,9.444V31.667A4.444,4.444,0,0,0,7.444,36.111Z"
        transform="translate(-1.613 -4)"
        fill="none"
        stroke="#1e3c70"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  ),
  developers: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="47"
      viewBox="0 0 42 47"
    >
      <path
        id="Path_16"
        data-name="Path 16"
        d="M4,13V38c0,5.525,8.955,10,20,10s20-4.475,20-10V13M4,13c0,5.525,8.955,10,20,10s20-4.475,20-10M4,13C4,7.475,12.955,3,24,3S44,7.475,44,13m0,12.5c0,5.525-8.955,10-20,10S4,31.025,4,25.5"
        transform="translate(-3 -2)"
        fill="none"
        stroke="#1e3c70"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  ),
  help: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="34.06"
      viewBox="0 0 42 34.06"
    >
      <path
        id="Path_17"
        data-name="Path 17"
        d="M23,7.784V36.673M23,7.784A18.229,18.229,0,0,0,13,5,18.229,18.229,0,0,0,3,7.784V36.673a18.229,18.229,0,0,1,10-2.784,18.229,18.229,0,0,1,10,2.784M23,7.784A18.229,18.229,0,0,1,33,5,18.224,18.224,0,0,1,43,7.784V36.673a18.224,18.224,0,0,0-10-2.784,18.229,18.229,0,0,0-10,2.784"
        transform="translate(-2 -4)"
        fill="none"
        stroke="#1e3c70"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  ),
};

export default function ContactUs() {
  const content = contactUs.en;
  const isMobile = useIsMobile();

  return (
    <main className={classes.container}>
      <Container>
        <section className="my-5">
          <h1 className="text-center">{content.title}</h1>
          <p className="text-center">{content.subTitle}</p>
        </section>
        <section className="my-5">
          <Row className={`${isMobile ? "w-100" : "w-75"} mx-auto`}>
            {content.cards.map(({ description, path, svgId, title }, i) => (
              <Col className="p-3" key={i} sm={6}>
                <Link href={path}>
                  <Card className={classes.card}>
                    <CardBody className="d-flex justify-content-center align-items-center">
                      <div className="text-secondary">
                        {svgMap[svgId as keyof typeof svgMap]}
                        <h6 className="mt-4 text-uppercase">{title}</h6>
                        <p>{description}</p>
                      </div>
                    </CardBody>
                  </Card>
                </Link>
              </Col>
            ))}
          </Row>
        </section>
      </Container>
    </main>
  );
}
